import type {
  SettingDefinition,
  SettingMetadata,
  TeamSettingsSettingValueSource,
} from "../../settings-catalog/types";
import type { InventoryGeneralFlatTeamSettingGroupId } from "./groups";

/**
 * Nothing on this page is cataloged: the groups carry its section wrappers, and
 * the cycle-count variance thresholds that lived here were removed.
 */
export const InventoryGeneralFlatTeamSettingCatalogDefinitions: readonly SettingDefinition<
  never,
  InventoryGeneralFlatTeamSettingGroupId,
  TeamSettingsSettingValueSource<never>
>[] = [];

export const InventoryGeneralFlatTeamSettingMetadataByKey: Record<
  never,
  SettingMetadata
> = {};
